'use client';
import React from 'react';
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import appRoutes from '@/constants/routes';
import AfiwaButton from '@/ui/shared/components/afiwaButton';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { motion } from 'framer-motion';
import backgroundImage from './assets/background.png';
import img1 from './assets/img1.png';
import img2 from './assets/img4.png';
import img3 from './assets/img7.png';
import img4 from './assets/img3.png';
import img5 from './assets/img5.png';
import clsx from 'clsx';

function GetStartedSection() {
  const getStartedText = useTranslations('about_us.get_started');
  const iconItems = [
    {
      src: '/icons/affordable-rates-icon.svg',
      alt: 'affordable-rates-icon',
      textKey: 'affordable_rates',
    },
    {
      src: '/icons/multiple-currencies-icon.svg',
      alt: 'multiple-currencies-icon',
      textKey: 'multiple_currencies',
    },
    {
      src: '/icons/support-icon.svg',
      alt: 'support-icon',
      textKey: 'support',
    },
  ];

  // frames
  const slides = [
    {
      index: '1',
      title: getStartedText('ready'),
      subTitle: getStartedText('get_started_now'),
      imagePath: img1,
    },
    {
      index: '2',
      title: getStartedText('letsGo'),
      subTitle: getStartedText('startSend'),
      imagePath: img2,
    },
    {
      index: '3',
      title: getStartedText('joinUs'),
      subTitle: getStartedText('seamless'),
      imagePath: img3,
    },
    {
      index: '4',
      title: 'Afiwa Exchange',
      subTitle: getStartedText('makeIt'),
      imagePath: img4,
    },
    {
      index: '5',
      title: getStartedText('dontMiss'),
      subTitle: getStartedText('joinafiwa'),
      imagePath: img5,
    },
  ];
  // states
  const [currentIndex, setCurrentIndex] = React.useState<number>(0);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000); // Update every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div
      className={`bg-second-gradient relative min-h-[600px] overflow-hidden rounded-3xl md:min-h-[400px]`}
    >
      {/* bg-image */}
      <Image
        src={backgroundImage}
        alt="bg-image"
        fill={true}
        className={'!top-0 '}
        style={{ objectFit: 'cover' }}
      />

      {/* content */}
      <div className="relative z-10 mx-5 mt-16 text-white md:mx-20 md:my-[100px]">
        {/* title and  */}
        <motion.div
          key={slides[currentIndex].title}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
        >
          <div className="mb-10 flex flex-col gap-2 font-extrabold  md:gap-3">
            <span className="text-sm sm:text-base md:text-xl">
              {slides[currentIndex].title}
            </span>
            <span className="text-lg md:text-2xl xl:text-3xl">
              {slides[currentIndex].subTitle}
            </span>
          </div>
        </motion.div>

        {/* list */}
        <div className="z-10 mb-10 space-y-2 text-[10px] md:text-sm">
          {iconItems.map((item, index) => (
            <div
              key={index}
              className="flex flex-row items-center space-x-3 md:space-x-5"
            >
              <Image src={item.src} alt={item.alt} width={25} height={25} />
              <span>{getStartedText(item.textKey)}</span>
            </div>
          ))}
        </div>

        {/* button */}
        <AfiwaButton
          type="primary"
          className="!bg-white font-bold !text-blue-600"
          href={appRoutes.signup}
          text={getStartedText('create_an_account_now')}
          rightIcon={<ArrowRightIcon height={15} width={15} />}
        />
      </div>

      {/* content-matching image */}
      <div
        className={clsx({
          'xl:right-109 absolute right-16 top-[360px] z-0 h-[300px] w-[250px] md:w-[450px] lg:right-0':
            true,
          'md:top-[10px]': currentIndex == 0,
          'md:top-[100px]': currentIndex == 1,
          'md:top-[11px]': currentIndex == 2,
          'md:top-[0px]': currentIndex == 3,
          'md:top-[30px]': currentIndex == 4,
        })}
      >
        <Image
          src={slides[currentIndex].imagePath}
          alt="slide-image"
          className={`absolute z-0`}
        />
      </div>
    </div>
  );
}

export default GetStartedSection;
